{
  "GATStudio": {
    "API_URL": "https://api.dev.gamelearn.io/",
    "ASSETS_URL": "https://min.int.st2.gamelearn.io/statics/gamelearn/resources",
    "CLIENT": "58dccfba26561500117caf53",
    "LOCAL_LOGIN": true,
    "RESOURCE_URL": "https://min.int.st2.gamelearn.io/cooked.gl-lms-storage/clients/",
    "SERVICE_ID": "d52c4f2e-c466-4304-aa71-1cd3c555716d",
    "SERVICE_URL": "https://services.dev.gamelearn.io",
    "TRANSLATIONS_URL": "https://min.int.gamelearn.io/gl-i18n/studio/"
  },
  "accounts": {
    "apiUrl": "https://api.dev.gamelearn.io",
    "contentful": {
      "accessToken": "ee5c130c30267ab908f08f5244773edc1fadfa3a02d456a8e68f6e5b4cbd53a6",
      "active": true,
      "contentTypeIds": {
        "warningMessage": "mensajeDeWarning"
      },
      "space": "fbgigh3s9vtp",
      "warningMessageActive": false
    },
    "cookieDomain": ".gamelearn.io",
    "dictionaryUrl": "https://min.int.gamelearn.io/gl-style-dictionary",
    "domain": "gamelearn.io",
    "journal": {
      "agent": "https://journal-agent.gamelearn.io/journal.js",
      "url": "https://api.dev.gamelearn.io/journal"
    },
    "lmsUrl": "https://admin.dev.gamelearn.io",
    "resourcesUrl": "https://min.int.st2.gamelearn.io/cooked.gl-lms-storage/clients/",
    "sentry": {
      "dsn": "https://57c687f097f64debb34663f73023f885@o436063.ingest.sentry.io/5623369",
      "show": true
    },
    "serviceId": "a0647baf-3ed5-484a-9240-4944dc7dbe5f",
    "serviceUrl": "https://services.dev.gamelearn.io?sid=a0647baf-3ed5-484a-9240-4944dc7dbe5f",
    "supportUrl": "https://support.game-learn.com",
    "surveyUrl": "https://surveyprepost.gamelearn.io/",
    "translationsUrl": "https://min.int.gamelearn.io/gl-i18n/accounts/"
  },
  "ai-frontend": {},
  "arcade": {
    "VITE_API_URL": "https://api.dev.gamelearn.io",
    "VITE_CAMPUS_URL": "https://campus.dev.gamelearn.io",
    "VITE_CLIENT": "58dccfba26561500117caf53",
    "VITE_COOKIE_DOMAIN": "domain=.gamelearn.io",
    "VITE_EMMET_URL": "https://script.dev.gamelearn.io/emmet",
    "VITE_MICROFRONTENDS": "dev",
    "VITE_MINIO_URL": "https://min.int.st2.gamelearn.io/",
    "VITE_RESOURCES_HOST": "https://min.int.st2.gamelearn.io/cooked.gl-lms-storage/clients/",
    "VITE_SERVICES_URL": "https://services.dev.gamelearn.io",
    "VITE_SERVICE_ID": "a03431b1-c799-4525-9400-bae0062e7afa",
    "VITE_STATICS_URL": "https://min.gamelearn.io/statics",
    "VITE_STORYLINES_DB": "https://storylinesdb.dev.gamelearn.io/fetch?url=",
    "VITE_STREAMING_HOST": "https://streaming.int.st2.gamelearn.io/clients/",
    "VITE_TRANSLATION_HOST": "https://min.int.gamelearn.io/gl-i18n/gat-games/",
    "VITE_TTS_URL": "https://ekho2.dev.gamelearn.io/api",
    "VITE_VOICES_URL": "https://ekho2.dev.gamelearn.io/api/file"
  },
  "arcade-animixer": {
    "VITE_API_URL": "https://api.dev.gamelearn.io",
    "VITE_CAMPUS_URL": "https://campus.dev.gamelearn.io",
    "VITE_CLIENT": "58dccfba26561500117caf53",
    "VITE_COOKIE_DOMAIN": "domain=.gamelearn.io",
    "VITE_JOURNAL_AGENT": "https://journal-agent.dev.gamelearn.io/journal.js",
    "VITE_JOURNAL_URL": "https://api.dev.gamelearn.io/journal",
    "VITE_MINIO_URL": "https://min.int.st2.gamelearn.io/",
    "VITE_RESOURCES_HOST": "https://min.int.st2.gamelearn.io/cooked.gl-lms-storage/clients/",
    "VITE_SERVICES_URL": "https://services.dev.gamelearn.io",
    "VITE_SERVICE_ID": "5154560c-e86c-45a2-8ff5-bc38f11535d3",
    "VITE_STATICS_URL": "https://min.gamelearn.io/statics",
    "VITE_TRANSLATION_HOST": "https://min.int.gamelearn.io/gl-i18n/gat-games/",
    "production": false
  },
  "arcade-studio": {
    "ACCOUNTS_URL": "https://accounts.dev.gamelearn.io/",
    "API_URL": "https://api.dev.gamelearn.io",
    "ASSETS_URL": "https://min.int.gamelearn.io/statics/",
    "CLIENT": "58dccfba26561500117caf53",
    "DEFAULT_SCENE_ID": "5f9be8835ca1de00112844d6",
    "DOMAIN": "domain=.gamelearn.io",
    "GEMINI_ENABLED": true,
    "KEPLER_ASSETS_URL": "https://min.gamelearn.io/kepler/assets",
    "REACT_APP_API_URL": "https://api.dev.gamelearn.io",
    "REACT_APP_CAMPUS_URL": "https://campus.dev.gamelearn.io",
    "REACT_APP_CLIENT": "58dccfba26561500117caf53",
    "REACT_APP_COOKIE_DOMAIN": "domain=.gamelearn.io",
    "REACT_APP_RESOURCES_HOST": "https://min.int.st2.gamelearn.io/cooked.gl-lms-storage/clients/",
    "REACT_APP_SERVICES_URL": "https://services.dev.gamelearn.io",
    "REACT_APP_STATICS_URL": "https://min.gamelearn.io/statics",
    "REACT_APP_TRANSLATION_HOST": "https://min.int.gamelearn.io/gl-i18n/gat-games/",
    "SERVICES_URL": "https://services.dev.gamelearn.io",
    "SERVICE_ID": "94cca5a3-0c00-4cff-8667-18f0da843c5f",
    "SERVICE_ID_EDITOR": "5154560c-e86c-45a2-8ff5-bc38f11535d3",
    "cookieDomain": "domain=.gamelearn.io",
    "production": false
  },
  "authoring-tool": {
    "ACCOUNTS_URL": "https://accounts.dev.gamelearn.io/",
    "API_URL": "https://api.dev.gamelearn.io",
    "ASSETS_URL": "https://min.int.gamelearn.io/statics/",
    "CLARITY": {
      "enabled": false
    },
    "CLIENT": "58dccfba26561500117caf53",
    "DEFAULT_SCENE_ID": "5e4c03fee7afe5000f3c8822",
    "DOMAIN": "gamelearn.io",
    "EDITOR_MULTIPLAYER_URL": "wss://editor-multiplayer.dev.gamelearn.io:443",
    "ENGINE_BACKEND": "https://api.dev.gamelearn.io/arcade",
    "ENGINE_LOGIN": "https://arcade.dev.gamelearn.io/",
    "LMS_URL": "https://admin.dev.gamelearn.io",
    "PLAYGROUND_URL": "https://arcade.dev.gamelearn.io/playground",
    "POLYGLOT_WEBSOCKET_URL": "wss://polyglot.dev.gamelearn.io:443",
    "PREVIEW_URL": "https://arcade.dev.gamelearn.io/preview",
    "RESOURCES_HOST": "https://min.int.st2.gamelearn.io/cooked.gl-lms-storage/clients/",
    "S3_BUCKET_PARAMS": {
      "Bucket": "https://min.int.gamelearn.io/statics/"
    },
    "SCENE_COMPOSER_URL": "https://scene-composer.dev.gamelearn.io",
    "SERVICES_URL": "https://services.dev.gamelearn.io",
    "SERVICE_ID": "5154560c-e86c-45a2-8ff5-bc38f11535d3",
    "STREAMING_HOST": "https://streaming.int.st2.gamelearn.io/clients/",
    "STUDENTS_URL": "https://campus.dev.gamelearn.io",
    "SUPPORT_URL": "https://support.game-learn.com",
    "TEXT_CLICK_CLIENT_IDS": "58dccfba26561500117caf53,64b520de331e4d2d65f5b838",
    "TRANSLATIONS_URL": "https://min.int.gamelearn.io/gl-i18n/authoring/",
    "TTS_URL": "https://ekho2.dev.gamelearn.io/api/",
    "VOICES_URL": "https://ekho2.dev.gamelearn.io/api/file/",
    "cookieDomain": ".gamelearn.io",
    "microfrontends": {
      "GlAccounts": {
        "active": true,
        "apiUrl": "https://api.dev.gamelearn.io",
        "authorization": true,
        "script": "https://script.dev.gamelearn.io/glaccounts/glaccounts.js",
        "tag": "accounts",
        "translationsUrl": "https://min.int.gamelearn.io/gl-i18n/accounts"
      },
      "GlCookies": {
        "active": true,
        "components": [
          "modal"
        ],
        "script": "https://script.dev.gamelearn.io/glcookies/glcookies.js",
        "tag": "cookies",
        "translationsUrl": "https://min.int.gamelearn.io/gl-i18n/services-platform"
      },
      "GlGtm": {
        "active": true,
        "apiUrl": "https://api.dev.gamelearn.io",
        "authorization": true,
        "gtmId": "GTM-W8LZP4K",
        "plugins": [
          "intercom"
        ],
        "script": "https://script.dev.gamelearn.io/glgtm/glgtm.js",
        "tag": "gtm"
      },
      "GlJournal": {
        "active": true,
        "apiUrl": "https://api.dev.gamelearn.io/journal",
        "authorization": true,
        "script": "https://script.dev.gamelearn.io/gljournal/gljournal.js",
        "tag": "journal"
      }
    },
    "production": false
  },
  "campus": {
    "GAMELEARN_CLIENT_ID": "58dccfba26561500117caf53",
    "apiUrl": "https://api.dev.gamelearn.io",
    "campusUrl": "https://campus.dev.gamelearn.io/",
    "contentful": {
      "accessToken": "ee5c130c30267ab908f08f5244773edc1fadfa3a02d456a8e68f6e5b4cbd53a6",
      "active": true,
      "contentTypeIds": {
        "warningMessage": "mensajeDeWarning"
      },
      "space": "fbgigh3s9vtp",
      "warningMessageActive": false
    },
    "cookieDomain": ".gamelearn.io",
    "dictionaryUrl": "https://min.int.gamelearn.io/gl-style-dictionary",
    "diplomasUrl": "https://share.dev.gamelearn.io/diplomas/",
    "domain": "dev.gamelearn.io",
    "editorUrl": "https://editor.dev.gamelearn.io/",
    "ft": {
      "enableLogin": true
    },
    "linkedinConfig": {
      "client_id": "78hvuxta6257fz",
      "redirect_uri": "https://api.dev.gamelearn.io/core/users/linkedin",
      "state": "nHGdG9G3SkWrWj6o"
    },
    "lmsUrl": "https://admin.dev.gamelearn.io/",
    "microfrontends": {
      "GlCookies": {
        "active": true,
        "components": [
          "modal"
        ],
        "script": "https://script.dev.gamelearn.io/glcookies/glcookies.js",
        "tag": "cookies",
        "translationsUrl": "https://min.int.gamelearn.io/gl-i18n/services-platform"
      },
      "GlGtm": {
        "active": true,
        "apiUrl": "https://api.dev.gamelearn.io",
        "authorization": true,
        "gtmId": "GTM-54VRXRK",
        "plugins": [
          "intercom"
        ],
        "script": "https://script.dev.gamelearn.io/glgtm/glgtm.js",
        "tag": "gtm"
      },
      "GlJournal": {
        "active": true,
        "apiUrl": "https://api.dev.gamelearn.io/journal",
        "authorization": true,
        "script": "https://script.dev.gamelearn.io/gljournal/gljournal.js",
        "tag": "journal"
      },
      "GlMentor": {
        "active": true,
        "apiUrl": "https://api.dev.gamelearn.io/emmet-campus",
        "authorization": true,
        "script": "https://script.dev.gamelearn.io/glmentor/glmentor.js",
        "tag": "mentor",
        "translationsUrl": "https://min.int.gamelearn.io/gl-i18n/campus/"
      },
      "GlRecommendy": {
        "active": true,
        "apiUrl": "https://api.dev.gamelearn.io",
        "authorization": true,
        "campusUrl": "https://campus.dev.gamelearn.io",
        "disableOnEmbeddedMode": true,
        "resourcesUrl": "https://min.int.st2.gamelearn.io/cooked.gl-lms-storage/clients/",
        "script": "https://script.dev.gamelearn.io/recommendy/recommendy.js",
        "tag": "recommendy"
      }
    },
    "pwa": {
      "msTileColor": "#990000",
      "name": "Campus_int",
      "themeColor": "#990000"
    },
    "resourcesUrl": "https://min.int.st2.gamelearn.io/cooked.gl-lms-storage/clients/",
    "sentry": {
      "dsn": "https://addf7db100074dc1aa2ad2f708380dad@o436063.ingest.sentry.io/5624290",
      "show": true
    },
    "serviceId": "a5c180aa-3ca0-4869-b79e-c6612c7490b8",
    "serviceIdPwa": "eff42bd7-b44d-4163-a51c-698bc0a804ef",
    "servicesUrl": "https://services.dev.gamelearn.io",
    "streamingUrl": "https://streaming.int.st2.gamelearn.io/clients/",
    "supportUrl": "https://support.game-learn.com",
    "translationsUrl": "https://min.int.gamelearn.io/gl-i18n/campus/"
  },
  "common": {
    "environment": "int",
    "services": {
      "0ef3a8c3-b219-4c10-905c-32f2c5feb4ef": "animixer",
      "1f41dd60-54ed-4eb1-9736-afea1cbd39eb": "resources",
      "23a1209f-8fa4-420c-ad01-d39515ae5c89": "roleplay",
      "3e1e6366-d4e9-4d97-adef-30dbf784428c": "bender",
      "50cb03f8-96d0-43a5-bf3a-9b119fb471e6": "admin",
      "5154560c-e86c-45a2-8ff5-bc38f11535d3": "editor",
      "623c139f-17de-4cea-a812-c96ab16d2ca0": "supervisor",
      "679ecd96-852c-49ce-a202-17aecb837eaf": "mars",
      "724876ad-4770-5359-aa18-799edafb6d1a": "lms",
      "7ef5ec6f-7f77-57d8-87c7-c7c47bf1a73e": "studentsPlatform",
      "813fa365-88fb-4de3-95e6-679b3a89290e": "services",
      "82c54e3e-60ac-43f1-a98a-3f39277ecf94": "reporting",
      "a03431b1-c799-4525-9400-bae0062e7afa": "arcade",
      "a0647baf-3ed5-484a-9240-4944dc7dbe5f": "accounts",
      "a5c180aa-3ca0-4869-b79e-c6612c7490b8": "campus",
      "d52c4f2e-c466-4304-aa71-1cd3c555716d": "studio",
      "dac71433-c04e-4a69-9bd9-047545960ce2": "kepler",
      "eff42bd7-b44d-4163-a51c-698bc0a804ef": "campusPwa"
    },
    "sids": {
      "accounts": "a0647baf-3ed5-484a-9240-4944dc7dbe5f",
      "admin": "50cb03f8-96d0-43a5-bf3a-9b119fb471e6",
      "animixer": "0ef3a8c3-b219-4c10-905c-32f2c5feb4ef",
      "arcade": "a03431b1-c799-4525-9400-bae0062e7afa",
      "bender": "3e1e6366-d4e9-4d97-adef-30dbf784428c",
      "campus": "a5c180aa-3ca0-4869-b79e-c6612c7490b8",
      "campusPwa": "eff42bd7-b44d-4163-a51c-698bc0a804ef",
      "editor": "5154560c-e86c-45a2-8ff5-bc38f11535d3",
      "kepler": "dac71433-c04e-4a69-9bd9-047545960ce2",
      "lms": "724876ad-4770-5359-aa18-799edafb6d1a",
      "mars": "679ecd96-852c-49ce-a202-17aecb837eaf",
      "reporting": "82c54e3e-60ac-43f1-a98a-3f39277ecf94",
      "resources": "1f41dd60-54ed-4eb1-9736-afea1cbd39eb",
      "roleplay": "23a1209f-8fa4-420c-ad01-d39515ae5c89",
      "services": "813fa365-88fb-4de3-95e6-679b3a89290e",
      "studentsPlatform": "7ef5ec6f-7f77-57d8-87c7-c7c47bf1a73e",
      "studio": "d52c4f2e-c466-4304-aa71-1cd3c555716d",
      "supervisor": "623c139f-17de-4cea-a812-c96ab16d2ca0"
    }
  },
  "game2100-frontend": {},
  "gat-engine-front": {
    "apiHost": "https://api.dev.gamelearn.io/",
    "assetsHost": "https://min.int.gamelearn.io/statics/gat/",
    "assetsMediaHost": "https://dszv2c8p7i9xo.cloudfront.net/",
    "backHost": "https://api.dev.gamelearn.io/gat-engine",
    "cookieDomain": "domain=.gamelearn.io",
    "resources": "https://min.int.st2.gamelearn.io/cooked.gl-lms-storage/clients/",
    "servicesUrl": "https://services.dev.gamelearn.io",
    "studentsPlatform": "https://campus.dev.gamelearn.io",
    "translationsHost": "https://min.int.gamelearn.io/gl-i18n/gat-games/"
  },
  "gl-roleplay": {
    "API_CLIENTS_URL": "/core/clients",
    "API_SUBSCRIPTIONS_URL": "/subscriptions",
    "apiUrl": "https://api.dev.gamelearn.io",
    "apiUrlRoleplay": "https://rest.kaepora.dev.gamelearn.io",
    "contentful": {
      "accessToken": "ee5c130c30267ab908f08f5244773edc1fadfa3a02d456a8e68f6e5b4cbd53a6",
      "space": "fbgigh3s9vtp"
    },
    "disableAskDeleteStatement": "roleplay_disableAskDeleteStatement",
    "kaeporaFrontendUrl": "https://kaepora.dev.gamelearn.io",
    "locale": "en",
    "mediaPrefix": "int",
    "resourcesUrl": "https://min.int.st2.gamelearn.io",
    "serviceId": "23a1209f-8fa4-420c-ad01-d39515ae5c89",
    "sid": "94cca5a3-0c00-4cff-8667-18f0da843c5f",
    "toolbarConfig": {
      "columnChooser": false,
      "filter": false,
      "roleplayFilters": false,
      "rowCountSelector": false,
      "search": true
    },
    "translationsUrl": "https://min.int.gamelearn.io/gl-i18n/kaepora"
  },
  "kaepora-frontend": {
    "VITE_API_URL": "https://api.dev.gamelearn.io",
    "VITE_COOKIE_DOMAIN": "domain=.gamelearn.io",
    "VITE_LIVEKIT_URL": "wss://livekit.im.roleplay.gs",
    "VITE_RESOURCES_HOST": "https://min.int.st2.gamelearn.io/kaepora/",
    "VITE_REST_URL": "https://rest.kaepora.dev.gamelearn.io",
    "VITE_SERVICES_URL": "https://services.dev.gamelearn.io",
    "VITE_SERVICE_ID": "23a1209f-8fa4-420c-ad01-d39515ae5c89",
    "VITE_TRANSLATION_HOST": "https://min.int.gamelearn.io/gl-i18n/kaepora/",
    "VITE_WEBSOCKET_REPORT_URL": "wss://report.kaepora.dev.gamelearn.io:443",
    "VITE_WEBSOCKET_URL": "wss://ws.kaepora.dev.gamelearn.io:443",
    "contentful": {
      "active": true,
      "contentTypeIds": {
        "warningMessageRp": "warningMessageRp"
      },
      "defaultLang": "en",
      "languages": [
        "en",
        "es",
        "fr",
        "de"
      ],
      "warningMessageActive": true
    },
    "microfrontends": {
      "GlCookies": {
        "active": true,
        "components": [
          "modal"
        ],
        "script": "https://script.dev.gamelearn.io/glcookies/glcookies.js",
        "tag": "cookies",
        "translationsUrl": "https://min.int.gamelearn.io/gl-i18n/services-platform"
      },
      "GlJournal": {
        "active": true,
        "apiUrl": "https://api.dev.gamelearn.io/journal",
        "authorization": true,
        "script": "https://script.dev.gamelearn.io/gljournal/gljournal.js",
        "tag": "journal"
      },
      "GlRoleplay": {
        "active": true,
        "apiUrl": "https://api.dev.gamelearn.io",
        "apiUrlRoleplay": "https://rest.kaepora.dev.gamelearn.io",
        "authorization": true,
        "resourcesUrl": "https://min.int.st2.gamelearn.io",
        "script": "https://script.dev.gamelearn.io/glroleplay/glroleplay.js",
        "tag": "roleplay",
        "translationsUrl": "https://min.int.gamelearn.io/gl-i18n/kaepora"
      }
    },
    "production": false
  },
  "kepler-frontend": {
    "VITE_API_URL": "https://api.dev.gamelearn.io",
    "VITE_ASSETS_URL": "https://min.int.gamelearn.io/kepler/assets",
    "VITE_CAMPUS_URL": "https://campus.dev.gamelearn.io",
    "VITE_CLIENT": "58dccfba26561500117caf53",
    "VITE_COOKIE_DOMAIN": "domain=.gamelearn.io",
    "VITE_JOURNAL_AGENT": "https://journal-agent.gamelearn.io/journal.js",
    "VITE_JOURNAL_URL": "https://api.dev.gamelearn.io/kepler-journal",
    "VITE_MINIO_URL": "https://min.int.st2.gamelearn.io/",
    "VITE_NODE_ENV": "development",
    "VITE_RESOURCES_HOST": "https://min.int.st2.gamelearn.io/cooked.gl-lms-storage/clients/",
    "VITE_SERVICES_URL": "https://services.dev.gamelearn.io",
    "VITE_SERVICE_ID": "dac71433-c04e-4a69-9bd9-047545960ce2",
    "VITE_SOCKETS_URL": "wss://kepler-knit.dev.gamelearn.io:443",
    "VITE_STATICS_URL": "https://min.gamelearn.io/statics",
    "VITE_STREAMING_HOST": "https://streaming.st2.gamelearn.io/",
    "VITE_TOS_CLIENT_IDS": "619271c748d5060011e89bf1",
    "VITE_TRANSLATION_HOST": "https://min.int.gamelearn.io/gl-i18n/kepler/",
    "production": false
  },
  "learning-management-system": {
    "ACCOUNTS_URL": "https://accounts.dev.gamelearn.io/",
    "API_URL": "https://api.dev.gamelearn.io",
    "AUTHORING_URL": "https://editor.dev.gamelearn.io",
    "CAMPUS_URL": "https://campus.dev.gamelearn.io/",
    "CLIENT": "58dccfba26561500117caf53",
    "DOMAIN": "gamelearn.io",
    "MARS_API_URL": "https://marsv2-api.dev.gamelearn.io",
    "MARS_ID": "5b969506faff8ad688def85c",
    "REPORTS_URL": "https://reporting.dev.gamelearn.io",
    "RESOURCES_HOST": "https://min.int.st2.gamelearn.io/cooked.gl-lms-storage/clients/",
    "SERVICES_URL": "https://services.dev.gamelearn.io",
    "SERVICE_ID": "50cb03f8-96d0-43a5-bf3a-9b119fb471e6",
    "STREAMING_HOST": "https://streaming.int.st2.gamelearn.io/clients/",
    "SUPERVISOR_URL": "https://supervisor.dev.gamelearn.io",
    "TRANSLATIONS_URL": "https://min.int.st2.gamelearn.io/gl-i18n/learning-management-system/",
    "contentful": {
      "active": true,
      "contentTypeIds": {
        "warningMessage": "mensajeDeWarning"
      },
      "warningMessageActive": false
    },
    "dictionaryUrl": "https://min.int.st2.gamelearn.io/gl-style-dictionary",
    "ft": {
      "enableLogin": false
    },
    "helpHero": {
      "hide": "true",
      "id": "OViXGTEquoc"
    },
    "keplerLanguages": [
      {
        "key": "en",
        "value": "languages.english"
      },
      {
        "key": "es",
        "value": "languages.spanish"
      },
      {
        "key": "fr",
        "value": "languages.french"
      }
    ],
    "microfrontends": {
      "GlAccounts": {
        "active": false,
        "apiUrl": "https://api.dev.gamelearn.io",
        "apiUrlMars": "https://marsv2-api.dev.gamelearn.io",
        "apiUrlRoleplay": "https://rest.kaepora.dev.gamelearn.io",
        "authorization": true,
        "routes": {
          "admins": "/agents",
          "clients": "/clients",
          "partners": "/distributors"
        },
        "script": "https://script.dev.gamelearn.io/glaccounts/glaccounts.js",
        "tag": "accounts",
        "translationsUrl": "https://min.int.gamelearn.io/gl-i18n/accounts"
      },
      "GlCookies": {
        "active": true,
        "components": [
          "modal"
        ],
        "script": "https://script.dev.gamelearn.io/glcookies/glcookies.js",
        "tag": "cookies",
        "translationsUrl": "https://min.int.gamelearn.io/gl-i18n/services-platform"
      },
      "GlGtm": {
        "active": true,
        "apiUrl": "https://api.dev.gamelearn.io",
        "authorization": true,
        "gtmId": "GTM-N8KZLB4",
        "plugins": [
          "intercom"
        ],
        "script": "https://script.dev.gamelearn.io/glgtm/glgtm.js",
        "tag": "gtm"
      },
      "GlJournal": {
        "active": true,
        "apiUrl": "https://api.dev.gamelearn.io/journal",
        "authorization": true,
        "script": "https://script.dev.gamelearn.io/gljournal/gljournal.js",
        "tag": "journal"
      },
      "GlReports": {
        "active": false,
        "apiUrl": "https://api.dev.gamelearn.io",
        "authorization": true,
        "script": "https://script.dev.gamelearn.io/glreports/glreports.js",
        "tag": "reports",
        "translationsUrl": "https://min.int.st2.gamelearn.io/gl-i18n/learning-management-system"
      },
      "GlRoleplay": {
        "active": true,
        "apiUrl": "https://api.dev.gamelearn.io",
        "apiUrlRoleplay": "https://rest.kaepora.dev.gamelearn.io",
        "authorization": true,
        "resourcesUrl": "https://min.int.st2.gamelearn.io",
        "script": "https://script.dev.gamelearn.io/glroleplay/glroleplay.js",
        "tag": "roleplay",
        "translationsUrl": "https://min.int.gamelearn.io/gl-i18n/kaepora"
      }
    },
    "oldGames": [
      "Merchants",
      "2100",
      "Triskelion5",
      "Pacific",
      "Mars",
      "ADA-GDPR",
      "RGPD",
      "PacificAirlines"
    ],
    "oldGamesCanonicNames": [
      "merchants",
      "2100",
      "triskelion_2018",
      "triskelion",
      "pacific",
      "mars",
      "ada",
      "ada_gdpr",
      "rgpd",
      "pacific_airlines"
    ],
    "production": false,
    "release": false,
    "sentry": {
      "dsn": "https://2854cdce1851431fa594a7b4f4c1d32c@o436063.ingest.sentry.io/5624301",
      "show": true
    },
    "servicesPlatform": "https://services.dev.gamelearn.io",
    "zendeskSupportUrl": "https://support.game-learn.com"
  },
  "mars-frontend": {},
  "merchants-frontend": {},
  "palantir": {
    "api": "https://api.dev.gamelearn.io",
    "cookieDomain": ".gamelearn.io",
    "github": {
      "client_id": "5b2f74cbe2a03ced2d5c",
      "url": "https://github.com/login/oauth/authorize"
    },
    "owl": "https://owl.int.gamelearn.co"
  },
  "reporting-tool": {
    "API_BIGQUERY_URL": "/reporting_sql (deprecated)",
    "API_CORE_URL": "/core",
    "API_CRAWLER_URL": "/crawler (deprecated)",
    "API_REPORTING_URL": "/reporting",
    "API_URL": "https://api.dev.gamelearn.io",
    "SERVICE_ID": "82c54e3e-60ac-43f1-a98a-3f39277ecf94",
    "TRANSLATIONS_URL": "https://min.int.gamelearn.io/gl-i18n/learning-management-system/",
    "dictionaryUrl": "https://min.int.gamelearn.io/gl-style-dictionary",
    "journal": {
      "agent": "https://journal-agent.gamelearn.io/journal.js",
      "url": "https://api.dev.gamelearn.io/journal"
    },
    "sentry": {
      "dsn": "https://5851520423bf4656852072beddd2e1da@o436063.ingest.sentry.io/5624291",
      "show": true
    }
  },
  "resources-manager-front": {
    "API_URL": "https://api.dev.gamelearn.io",
    "CLIENT": "58dccfba26561500117caf53",
    "DOMAIN": "int.resources",
    "RESOURCES_URL": "https://min.int.st2.gamelearn.io/cooked.gl-lms-storage/clients/",
    "SCENE_COMPOSER_URL": "https://scene-composer.dev.gamelearn.io",
    "SERVICES_UID": "1f41dd60-54ed-4eb1-9736-afea1cbd39eb",
    "SERVICES_URL": "https://services.dev.gamelearn.io",
    "TRANSLATIONS_URL": "https://min.int.st2.gamelearn.io/gl-i18n/int/authoring/"
  },
  "scene-composer": {
    "VITE_RESOURCES_HOST": "https://min.int.st2.gamelearn.io/cooked.gl-lms-storage/clients/",
    "VITE_STATICS_URL": "https://min.gamelearn.io/css-resources"
  },
  "services-platform": {
    "API_URL": "https://api.dev.gamelearn.io",
    "LIVEKIT_URL": "wss://livekit.im.roleplay.gs",
    "LIVEKIT_TOKEN_URL": "https://rest.kaepora.dev.gamelearn.io/livekit/preflight-token",
    "CAMPUS_SID": "a5c180aa-3ca0-4869-b79e-c6612c7490b8",
    "CAMPUS_URL": "https://campus.dev.gamelearn.io",
    "DOMAIN": "gamelearn.io",
    "ENV": "int",
    "RECAPTCHA_SITEKEY": "6LcZUmkUAAAAAGWPYaPDi5nMHDcPGC7LXpfHY-u5",
    "RECAPTCHA_TEST_SITEKEY": "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
    "RESOURCES_HOST": "https://min.int.st2.gamelearn.io/cooked.gl-lms-storage/clients/",
    "TRANSLATIONS_URL": "https://min.int.gamelearn.io/gl-i18n/services-platform/",
    "contentful": {
      "accessToken": "ee5c130c30267ab908f08f5244773edc1fadfa3a02d456a8e68f6e5b4cbd53a6",
      "active": true,
      "space": "fbgigh3s9vtp"
    },
    "dictionaryUrl": "https://min.int.gamelearn.io/gl-style-dictionary",
    "gtm": {
      "enabled": false
    },
    "microfrontends": {
      "GlCookies": {
        "active": true,
        "components": [
          "banner",
          "footer"
        ],
        "script": "https://script.dev.gamelearn.io/glcookies/glcookies.js",
        "tag": "cookies",
        "translationsUrl": "https://min.int.gamelearn.io/gl-i18n/services-platform"
      }
    },
    "oldGamesCanonicNames": [
      "merchants",
      "2100",
      "triskelion_2018",
      "triskelion",
      "pacific",
      "mars",
      "ada",
      "ada_gdpr",
      "rgpd",
      "pacific_airlines"
    ],
    "production": false,
    "sentry": {
      "dsn": "https://3858152c7bb04307af4a34f94e910762@o436063.ingest.sentry.io/5624347",
      "show": true
    }
  },
  "students-platform": {
    "DOMAIN": "gamelearn.io",
    "apiUrl": "https://api.dev.gamelearn.io",
    "contentful": {
      "accessToken": "ee5c130c30267ab908f08f5244773edc1fadfa3a02d456a8e68f6e5b4cbd53a6",
      "active": false,
      "contentTypeIds": {
        "mensajeDeWarning": "mensajeDeWarning"
      },
      "space": "fbgigh3s9vtp",
      "warningMessageActive": false
    },
    "production": false,
    "release": false,
    "servicesPlatform": "https://services.dev.gamelearn.io",
    "translationsUrl": "https://min.int.gamelearn.io/gl-i18n/students-platform/",
    "zendeskSupportUrl": "https://support.game-learn.com"
  },
  "supervisor-portal": {
    "BuketS3Link": "https://min.int.gamelearn.io/fundae/",
    "TRANSLATIONS_URL": "https://min.int.gamelearn.io/gl-i18n/learning-management-system/",
    "apiUrl": "https://api.dev.gamelearn.io",
    "gtm": {
      "enabled": false
    },
    "production": false,
    "serviceId": "623c139f-17de-4cea-a812-c96ab16d2ca0"
  },
  "triskelion-frontend": {}
}
